import './GoBackButton.css';

import React from 'react';

interface GoBackButtonProps {
  onClick: () => void
  disabled?: boolean
}

export const GoBackButton = ({ onClick, disabled = false }: GoBackButtonProps): JSX.Element => {
  return (
    <button id="wifi_connection_go_back" onClick={onClick} disabled={disabled}>
      <i id="wifi_connection_go_back_icon" className="icon-chevron" />
      <span id="wifi_connection_go_back_label">Back</span>
    </button>
  );
};
